import { Dispatch } from 'store/store';
import { AnyAction } from '@reduxjs/toolkit';
import ClickstreamService, {
    ClickstreamEventType,
} from 'clickstream/ClickstreamService';

export const handleErrorsMiddleware = (
    clickstreamService: ClickstreamService
) => {
    return () => (next: Dispatch<AnyAction>) => (action: AnyAction) => {
        if (action.payload && action.payload.error) {
            clickstreamService.postEvent(
                ClickstreamEventType.ERROR,
                action.payload.error
            );
        }

        next(action);
    };
};
